import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { ICategory } from "../../types/cart";
import { IProductOffering } from "../../types/order";
import Product from "./Product";

interface Props {
  category: ICategory;
  id?: string;
}

const Category: FC<Props> = ({ category, id }) => (
  <Grid item xs={12} id={id}>
    <Typography
      variant="h4"
      component="h2"
      gutterBottom
      sx={{
        backgroundColor: "#447737",
        borderRadius: "0.5rem",
        color: "#f5f2e5",
        padding: "1rem",
      }}
    >
      {category.name}
    </Typography>
    <Grid alignItems="stretch" container item spacing={2}>
      {category.products.map((offering: IProductOffering) =>
        offering.stock > 0 || offering.unlimited_stock ? (
          <Product key={offering.id} product={offering} />
        ) : null,
      )}
    </Grid>
  </Grid>
);

export default Category;
